class StockNotificationForm extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('[data-stock-notification-form]');
    this.input = this.querySelector('[data-stock-notification-input]');
    this.submitButton = this.querySelector('[data-stock-notification-submit]');
    this.error = this.querySelector('[data-stock-notification-error]');
    this.status = this.querySelector('[data-stock-notification-status]');
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    if (!this.form.checkValidity()) return;

    event.preventDefault();
    const submittedEmail = this.input.value;
    // Built before setSubmitting disables the input: FormData skips disabled controls.
    const payload = new FormData(this.form);
    this.setSubmitting(true);

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: payload,
        headers: { Accept: 'text/html' },
      });
      const result = new DOMParser().parseFromString(await response.text(), 'text/html');

      if (!response.ok || !result.querySelector('[data-stock-notification-success]')) {
        const message = result.querySelector('[data-stock-notification-error]')?.textContent.trim();
        throw new Error(message || 'Could not submit your email. Please try again.');
      }

      this.dataset.state = 'success';
      this.input.value = submittedEmail;
      this.input.disabled = true;
      this.submitButton.hidden = true;
      this.error.hidden = true;
      this.status.textContent = 'Email submitted successfully';
    } catch (error) {
      this.dataset.state = 'error';
      this.input.value = submittedEmail;
      this.input.disabled = false;
      this.submitButton.hidden = false;
      this.submitButton.disabled = false;
      this.error.textContent = error.message;
      this.error.hidden = false;
      this.status.textContent = '';
    }
  }

  setSubmitting(isSubmitting) {
    this.dataset.state = isSubmitting ? 'submitting' : 'idle';
    this.input.disabled = isSubmitting;
    this.submitButton.disabled = isSubmitting;
  }
}

if (!customElements.get('stock-notification-form')) {
  customElements.define('stock-notification-form', StockNotificationForm);
}
